/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
/**
 * <p>This enum signifies the type of the ServiceProvider Identifier.<\/p>
 **/
export var ServiceProviderIdentifierType;
(function (ServiceProviderIdentifierType) {
    ServiceProviderIdentifierType["LOGISTICS_PARTY_ID"] = "LOGISTICS_PARTY_ID";
    ServiceProviderIdentifierType["DSP_COMPANY_ID"] = "DSP_COMPANY_ID";
})(ServiceProviderIdentifierType || (ServiceProviderIdentifierType = {}));
